import React, { JSX, useContext, useState } from 'react'

export const ModeReactContext = React.createContext<{
    mode: string
    setMode: React.Dispatch<React.SetStateAction<string>>
    fundingMode: string
    setFundingMode: React.Dispatch<React.SetStateAction<string>>
    deductionMode: string
    setDeductionMode: React.Dispatch<React.SetStateAction<string>>
}>({
    mode: '',
    setMode: () => {},
    fundingMode: '',
    setFundingMode: () => {},
    deductionMode: '',
    setDeductionMode: () => {},
})

export function ModeContext() {
    return useContext(ModeReactContext)
}

export function ModeProvider({ children }: { children: JSX.Element }) {
    const [mode, setMode] = useState<string>('')
    const [fundingMode, setFundingMode] = useState<string>('')
    const [deductionMode, setDeductionMode] = useState<string>('')

    return (
        <ModeReactContext.Provider
            value={{
                mode,
                setMode,
                fundingMode,
                setFundingMode,
                deductionMode,
                setDeductionMode,
            }}
        >
            {children}
        </ModeReactContext.Provider>
    )
}
